import { useQuery } from "@tanstack/react-query";
import type { fluidPay } from "../types";
import { useFluidPayApi } from "../context";
import { FLUID_PAY_QUERY_KEYS } from "../query-keys";

interface UseCustomerPaymentMethodsResult {
  paymentMethods: fluidPay.CustomerPaymentMethod[];
  isLoading: boolean;
  error: Error | null;
  refetch: () => void;
}

export function useCustomerPaymentMethods(
  customerId: number | undefined,
  jwt: string | undefined,
  countryCode?: string,
): UseCustomerPaymentMethodsResult {
  const api = useFluidPayApi();
  const hasValidJwt = !!jwt && jwt.trim().length > 0;

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: FLUID_PAY_QUERY_KEYS.paymentMethods(customerId!, countryCode),
    queryFn: async () => api.paymentMethods.fetchAll(jwt!, countryCode),
    enabled: hasValidJwt && !!customerId,
  });

  return {
    paymentMethods: data?.payment_methods ?? [],
    isLoading,
    error: error as Error | null,
    refetch,
  };
}
